import { Card } from '@mui/material';
import React from 'react';

interface Props {
  title: string;
  children?: any;
}

const PageTitle = (props: Props) => {
  return (
    <Card sx={{ padding: '10px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
      <span>{props.title}</span>
      {props.children}
    </Card>
  );
};

export default PageTitle;
